module.exports = __webpack_public_path__ + "static/nasa-31ce55499bb3baa38830385be8799af1.png";